export default "__VITE_ASSET__DhM3ODl5__"